var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-file-input',_vm._g(_vm._b({attrs:{"outlined":_vm.outlined,"multiple":_vm.multiple,"chips":_vm.chips,"prepend-icon":_vm.prependIcon,"prepend-inner-icon":_vm.prependInnerIcon,"label":_vm.label}},'v-file-input',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }